import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-info",
  "use": "icon-cl-info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-info\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 7a1 1 0 0 1 2 0v6h.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1H7V7Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol